/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CommitStackRuleChangesInput = {|
  greenMachineSessionId: string,
  existingRuleId?: ?string,
  name?: ?string,
  stackRuleId: string,
  stackValue: number,
  numLineups: number,
  required: boolean,
  players: $ReadOnlyArray<?string>,
  gcStaffStack?: ?boolean,
  lockIds?: ?$ReadOnlyArray<?string>,
  clientMutationId?: ?string,
|};
export type CommitStackRuleChangesMutationVariables = {|
  input: CommitStackRuleChangesInput
|};
export type CommitStackRuleChangesMutationResponse = {|
  +commitStackRuleChanges: ?{|
    +success: ?boolean
  |}
|};
export type CommitStackRuleChangesMutation = {|
  variables: CommitStackRuleChangesMutationVariables,
  response: CommitStackRuleChangesMutationResponse,
|};
*/


/*
mutation CommitStackRuleChangesMutation(
  $input: CommitStackRuleChangesInput!
) {
  commitStackRuleChanges(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CommitStackRuleChangesPayload",
    "kind": "LinkedField",
    "name": "commitStackRuleChanges",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommitStackRuleChangesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommitStackRuleChangesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cdf6d2c4ba46791f7bf9e4d32fe7c21a",
    "id": null,
    "metadata": {},
    "name": "CommitStackRuleChangesMutation",
    "operationKind": "mutation",
    "text": "mutation CommitStackRuleChangesMutation(\n  $input: CommitStackRuleChangesInput!\n) {\n  commitStackRuleChanges(input: $input) {\n    success\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fb28837b1adbaaa178c54102ac2630e2';

module.exports = node;
